// extracted by mini-css-extract-plugin
module.exports = {"bannerSimple":"BannerSimple_bannerSimple__x36v_"};